module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"modalTitle":"Send test email","confirm":"Send test","emailLabel":"Test email recipient","contactLabel":"Populate merge fields using this contact\u0027s details:","contactSubtitle":"This won\u0027t send them an email. It\u0027s simply meant to show you how your fields will populate."}}')
  delete Component.options._Ctor
}
